<template>
  <div class="p-field p-col-6 p-sm-5 p-lg-2">
    <AppFormItem label="Data Início">
      <Calendar
        :modelValue="dateStart"
        @update:modelValue="$emit('update:dateStart', $event)"
        dateFormat="dd/mm/yy"
        showIcon
        :monthNavigator="true"
        :yearNavigator="true"
        :yearRange="dateRange"
        :showOnFocus="false"
        v-mask="'##/##/####'"
      />
    </AppFormItem>
  </div>
  <div class="p-field p-col-6 p-sm-5 p-lg-2">
    <AppFormItem label="Data Fim">
      <Calendar
        :modelValue="dateEnd"
        @update:modelValue="$emit('update:dateEnd', $event)"
        dateFormat="dd/mm/yy"
        showIcon
        :monthNavigator="true"
        :yearNavigator="true"
        :yearRange="dateRange"
        :minDate="dateStart"
        :showOnFocus="false"
        v-mask="'##/##/####'"
      />
    </AppFormItem>
  </div>
</template>

<script>
export default {
  name: 'ServiceEditDate',
  props: {
    dateStart: Object,
    dateEnd: Object,
  },
  data() {
    return {
      dateRange: `${this.$dayjs()
        .subtract(10, 'y')
        .format('YYYY')}:${this.$dayjs().add(10, 'y').format('YYYY')}`,
    };
  },
};
</script>

<style>
</style>